// Nome fixo pelo contrato do DS (`<pasta>.tsx`); abriga a barra (`GanttBar`), o átomo principal.
import type { GanttBarProps } from "./types-gantt";
import { useGanttBar } from "./use-gantt";
import { GanttBarView } from "./view-gantt";

/**
 * Barra do Gantt, posicionada em % da linha do tempo e pela faixa do layout. Átomo puro: sem tooltip nem regras de
 * negócio; quem monta a linha calcula `start`/`end`. Com `onClick` vira botão (teclado incluído).
 */
export function GanttBar(props: GanttBarProps) {
  const viewModel = useGanttBar(props);

  return <GanttBarView {...viewModel} />;
}
GanttBar.displayName = "GanttBar";
